import React from 'react';
import { Thermometer, Moon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  return <section className="py-14 px-4 relative overflow-hidden" data-id="element-151">
      {/* Background Glows */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold-500/5 via-navy-900/0 to-navy-900/0 pointer-events-none" data-id="element-152" />

      <div className="max-w-5xl mx-auto" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="relative rounded-3xl p-[1px] bg-gradient-to-b from-gold-400/50 to-transparent" data-id="element-155">
            <div className="glass-card rounded-2xl p-6 md:p-10 bg-navy-800/80 backdrop-blur-xl" data-id="element-156">
              <div className="flex flex-col items-center text-center mb-8" data-id="element-157">
                <div className="flex gap-3 mb-4" data-id="element-158">
                  <div className="w-12 h-12 rounded-full bg-gold-500/10 flex items-center justify-center border border-gold-500/20" data-id="element-159">
                    <Thermometer className="w-6 h-6 text-gold-400" strokeWidth={1.5} data-id="element-160" />
                  </div>
                  <div className="w-12 h-12 rounded-full bg-lavender-400/10 flex items-center justify-center border border-lavender-400/20" data-id="element-161">
                    <Moon className="w-6 h-6 text-lavender-400" strokeWidth={1.5} data-id="element-162" />
                  </div>
                </div>

                <h2 className="text-2xl md:text-4xl font-heading font-bold text-gold-400 mb-4" data-id="element-163">
                  El Bio-Reset Térmico y Lumínico
                </h2>
                <p className="text-lg text-warmWhite-100 max-w-2xl font-medium" data-id="element-164">
                  Este sistema no es una receta, es un protocolo de señales
                  biológicas.
                </p>
              </div>

              <div className="text-lg text-warmWhite-200 leading-relaxed max-w-3xl mx-auto text-center" data-id="element-165">
                <p data-id="element-166">
                  En lugar de luchar contra tu insomnio, usamos rituales
                  específicos de temperatura{' '}
                  <span className="text-gold-400 font-medium" data-id="element-167">
                    (el secreto de los 18 grados)
                  </span>{' '}
                  y bloqueo de luz ámbar para obligar a tu cerebro a fabricar su
                  propia melatonina natural, bajando tus niveles de cortisol de
                  forma inmediata.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}